import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ClaveData from '../../../models/helperTypes/ClaveData';

export const initialState: ClaveData = {
  redirectUrl: `${window.location.origin}/payment/clave`,
  sessionId: '',
  paymentUrl: '',
};

const claveDataSlice = createSlice({
  name: 'claveData',
  initialState,
  reducers: {
    updateSessionId: (state, action: PayloadAction<string>): void => {
      state.sessionId = action.payload;
    },
    updatePaymentUrl: (state, action: PayloadAction<string>): void => {
      state.paymentUrl = action.payload;
    },
  },
});

export const { updateSessionId, updatePaymentUrl } = claveDataSlice.actions;

export default claveDataSlice.reducer;
